import {useRoutes} from 'react-router-dom';

import UnauthorizedRoutes from './UnauthorizedRoutes';
import SuperAdminAuthorizedRoutes from "./SuperAdminAuthorizedRoutes";
import UserAuthorizedRoutes from "./UserAuthorizedRoutes";
import {useSelector} from "react-redux";
import {getState} from "../../redux/actions/actions";
import OwnerAuthorizedRoutes from "./OwnerAuthorizedRoutes";
import AdminAuthorizedRoutes from "./AdminAuthorizedRoutes";
import ReportUserAuthorizedRoutes from './ReportUserAuthorizedRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const authState = useSelector((state: any) => state.auth.authData);
    const user = getState(authState);
    // console.log(user)

    const ROLES_ROUTES: any = {
        0: SuperAdminAuthorizedRoutes(0),
        1: AdminAuthorizedRoutes(1),
        2: OwnerAuthorizedRoutes(2),
        3: UserAuthorizedRoutes(3),
        4: ReportUserAuthorizedRoutes(4),
        undefined: UnauthorizedRoutes(user)
    };

    return useRoutes(user ? ROLES_ROUTES[Number(user?.role)] || UnauthorizedRoutes(user) : UnauthorizedRoutes(user));
}

// const ROLES_ROUTES: any = {
//     0: SuperAdminAuthorizedRoutes(0),
//     1: AdminAuthorizedRoutes(1),
//     2: OwnerAuthorizedRoutes(2),
//     3: UserAuthorizedRoutes(3),
//     4: ReportUserAuthorizedRoutes(4),
//     undefined: UnauthorizedRoutes(user)
// };
